import { CardEntityError } from '@shared/scenes/entity/create/hooks/useFormErrors';

export function getFieldError(errors: CardEntityError[], componentId: string) {
  const error = errors.find(item => item.componentId === componentId);
  return error?.description ?? undefined;
}
